<template>
  <div id="End">
    <bg-video ref="bv" filename="End" autoplay @ended="$router.push('/')"/>
    <guide-button v-show="btnVisiable" class="btn-cb" @click.native="$router.push('/')">感谢参观</guide-button>
  </div>
</template>

<script>
export default {
  name: 'End',
  data () {
    return {
      btnVisiable: false,
      filename: 'End',
    }
  },
}
</script>

<style lang="scss" scoped>
.nav-text {
  display: inline-block;
  width: 15.5rem;
  margin-top: -0.8rem;
}
</style>
